import { render, staticRenderFns } from "./TaskHome.vue?vue&type=template&id=d133e2b6&"
import script from "./TaskHome.vue?vue&type=script&lang=ts&"
export * from "./TaskHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports